/**
 * Toast — single-card visual for the in-app notification stack. Pure
 * presentation; lifetime/queueing lives in ToastProvider.
 *
 * Variants reuse the design system's status palette (positive / accent /
 * warning / danger) via a 2px left border. No shadow — sits flat against
 * the page like every other surface.
 */
import type { ReactNode } from 'react';

export type ToastVariant = 'success' | 'info' | 'warning' | 'error';

export interface ToastProps {
  variant: ToastVariant;
  title?: string;
  body: ReactNode;
  onDismiss: () => void;
}

export function Toast({ variant, title, body, onDismiss }: ToastProps) {
  return (
    <div
      className={`toast toast-${variant}`}
      role="status"
      aria-live="polite"
      onClick={onDismiss}
      title="Click to dismiss"
    >
      <div className="toast-content">
        {title && <div className="toast-title">{title}</div>}
        <div className="toast-body">{body}</div>
      </div>
      <button
        type="button"
        className="toast-close"
        aria-label="Dismiss"
        onClick={(e) => {
          e.stopPropagation();
          onDismiss();
        }}
      >
        ×
      </button>
    </div>
  );
}
